import { CFDIs as componentsCfDIs } from "./CFDIs";
import componentsCFDIFile from "./CFDIFile";

export const CFDIs = componentsCfDIs;
export const CFDIFile = componentsCFDIFile;
